// extracted by css-extract-rspack-plugin
export default {"chipIcon":"c7qAzJ4S8wQvxMQl"};